<template>
  <b-container>
    <b-row>
      <b-col class="h-20 logo" cols="2">
        <img src="@/assets/5895deb9cba9841eabab6099.png" width="50px" height="60px">
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="5"
        order-md="1"
        order="2"
        style="padding-left: 40px; padding-right: 40px;"
      >
        <!-- style="height: 100vh; padding-left: 40px; padding-right: 40px;" -->

        <b-col class="h-20 header-text" cols="12">
          <div>
            <h2 class="text-left">Welcome!</h2>
          </div>
        </b-col>

        <b-col cols="12" class="intro-text">
          <div>
            <p
              class="text-left"
            >New season, new plans. Use this guided tool to help you select the correct plan for you.</p>
          </div>
        </b-col>

        <b-col cols="12" md="12">
          <b-button block size="lg" v-on:click="onNext">Get started</b-button>
        </b-col>
      </b-col>

      <b-col cols="12" md="7" order-md="2" order="1">
        <div>
          <MyLottie :item="selected"/>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import MyLottie from "@/components/MyLottie.vue";
export default {
  name: "Start",
  data: function() {
    return {
      myValue: 0,
      selected: {
        value: 0,
        segments: [0, 74]
      }
    };
  },
  components: {
    MyLottie
  },
  props: {
    msg: String
  },
  mounted() {
    console.log("App mounted!");
    // we bring from the local storage the data of the questions
    if (localStorage.getItem("answers"))
      this.answers = JSON.parse(localStorage.getItem("answers"));
  },
  watch: {
    answers: {
      handler() {
        console.log("Todos changed!");
        // if we detect any change in the answers, we store them in localstorage
        localStorage.setItem("answers", JSON.stringify(this.answers));
      },
      deep: true
    }
  },
  methods: {
    /**
     * We use this method to show the following question
     */
    onNext(next) {
      this.$router.push({ name: "question" });
    },

    /**
     * This method is responsible for obtaining the response of the slider
     */
    getAnswer(answer) {
      // We updated the response of the json array
      this.answers[0].answer = parseInt(answer, 10) + 1;
      console.log("answer", answer);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-text {
  margin-top: 20%;
  margin-bottom: 30px;
  padding-left: 30px;
}

@media only screen and (max-width: 600px) {
  .header-text {
    margin-top: 0;
  }
}
@media only screen and (min-width: 767px) {
  div#myLottie {
    position: relative;
    bottom: 0;
  }
}
.intro-text {
  padding-left: 30px;
}
div#myLottie {
  position: relative;
  bottom: 80px;
}
button.btn.btn-secondary.btn-lg {
  background-color: #004986;
  border-radius: 15px;
}
button.btn.btn-secondary.btn-lg:hover {
  background-color: #004986c7;
  cursor: pointer;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  div#myLottie {
    position: relative;
    bottom: 0;
  }
  .header-text {
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0px;
  }
  h2 {
    text-align: center !important;
  }
  p {
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 14px;
  }

  .intro-text {
    padding-left: 0;
    margin-top: 0;
    margin-bottom: 0;
  }

  button.btn.btn-secondary.btn-lg {
    background-color: #004986;
    margin-top: 32px;
  }
  button.btn.btn-secondary.btn-lg:hover {
    background-color: #004986c7;
    cursor: pointer;
  }
  .logo {
    padding-left: 33px;
  }
}

.alto {
  height: 50px;
  width: 50px;
}
</style>
